import { render, staticRenderFns } from "./RosterLeavesListApplied.vue?vue&type=template&id=2db5a9d1"
import script from "./RosterLeavesListApplied.vue?vue&type=script&lang=js"
export * from "./RosterLeavesListApplied.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports